// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"10f3e89c","977":"5cc2826a"}[chunkId] + ".chunk.js";
};